import * as React from 'react';

/**
 * The component return users icon
 * @return {React.ReactElement}
 * @constructor
 */
export default function IconUsers(): React.ReactElement {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path d="M10 8.07129C11.8769 8.07129 13.3984 6.54976 13.3984 4.67285C13.3984 2.79595 11.8769 1.27441 10 1.27441C8.12309 1.27441 6.60156 2.79595 6.60156 4.67285C6.60156 6.54976 8.12309 8.07129 10 8.07129Z" />
        <path d="M16.875 8.07129C18.0615 8.07129 19.0234 7.10941 19.0234 5.92285C19.0234 4.7363 18.0615 3.77441 16.875 3.77441C15.6885 3.77441 14.7266 4.7363 14.7266 5.92285C14.7266 7.10941 15.6885 8.07129 16.875 8.07129Z" />
        <path d="M3.125 8.07129C4.31155 8.07129 5.27344 7.10941 5.27344 5.92285C5.27344 4.7363 4.31155 3.77441 3.125 3.77441C1.93845 3.77441 0.976562 4.7363 0.976562 5.92285C0.976562 7.10941 1.93845 8.07129 3.125 8.07129Z" />
        <path d="M5.2418 10.0007C4.39609 9.30781 3.6302 9.39953 2.65234 9.39953C1.18984 9.39953 0 10.5823 0 12.0359V16.3019C0 16.9331 0.515234 17.4464 1.14883 17.4464C3.88422 17.4464 3.55469 17.4959 3.55469 17.3284C3.55469 14.3055 3.19664 12.0887 5.2418 10.0007Z" />
        <path d="M10.9302 9.41523C9.22222 9.27277 7.73765 9.41687 6.45715 10.4738C4.31429 12.1902 4.72668 14.5013 4.72668 17.3285C4.72668 18.0765 5.33527 18.6965 6.09465 18.6965C14.34 18.6965 14.6682 18.9624 15.1571 17.8797C15.3175 17.5135 15.2735 17.6299 15.2735 14.1269C15.2735 11.3447 12.8644 9.41523 10.9302 9.41523Z" />
        <path d="M17.3475 9.39943C16.3643 9.39943 15.6026 9.30865 14.7581 10.0006C16.7879 12.0731 16.4452 14.1387 16.4452 17.3283C16.4452 17.4968 16.1716 17.4463 18.81 17.4463C19.4663 17.4463 19.9999 16.9147 19.9999 16.2611V12.0358C19.9999 10.5822 18.81 9.39943 17.3475 9.39943Z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20" fill="currentColor"/>
        </clipPath>
      </defs>
    </svg>

  );
}

